import { render, staticRenderFns } from "./AboutAchievement.vue?vue&type=template&id=daa0a2b4&"
import script from "./AboutAchievement.vue?vue&type=script&lang=js&"
export * from "./AboutAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports